import { render, staticRenderFns } from "./cv3.vue?vue&type=template&id=5f386132&scoped=true&"
import script from "./cv3.vue?vue&type=script&lang=js&"
export * from "./cv3.vue?vue&type=script&lang=js&"
import style0 from "./cv3.vue?vue&type=style&index=0&id=5f386132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f386132",
  null
  
)

export default component.exports